export var SpeechMarkerName;
(function (SpeechMarkerName) {
    SpeechMarkerName["Showcards"] = "showcards";
    SpeechMarkerName["Hidecards"] = "hidecards";
    SpeechMarkerName["Feature"] = "feature";
    SpeechMarkerName["Marker"] = "marker";
})(SpeechMarkerName || (SpeechMarkerName = {}));
//# sourceMappingURL=SpeechMarker.js.map